import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import { UseProductGifts } from "./UseProductGifts";
import SearchComGift from "./SearchComGift";
import { useSnackbar } from "notistack";
import ClearIcon from "@mui/icons-material/Clear";
import CircleIcon from "@mui/icons-material/Circle";
import GiftSearchCom from "./GiftSearchCom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function ProductGiftChange(props) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    ChangeProductGift,
    deleteProductgifts,
    getFilterCount,
    getProductByID,
  } = UseProductGifts();
  const [openGift, setOpenGift] = useState(false);
  const [filterCount, setFilterCount] = useState();
  const [giftName, setGiftName] = useState("");
  const [state, setState] = useState({
    giftID: undefined,
    newGiftId: undefined,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (openGift) {
      let newBody = Object.fromEntries(
        Object.entries(state).filter(([_, v]) => v != undefined)
      );
      getFilterCount(newBody, (callback) => {
        setFilterCount(callback);
      });
    }
  }, [openGift]);

  return (
    <Box>
      <Dialog
        open={openGift}
        maxWidth="sm"
        fullWidth
        onClose={() => {
          setState({
            ...state,
            newGiftId: undefined,
          });
          setGiftName("");
          setOpenGift(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{}}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography color="secondary" variant="subtitle2">
              {filterCount} مورد یافت شد
            </Typography>
            <IconButton
              onClick={() => {
                setState({
                  ...state,
                  newGiftId: undefined,
                });
                setGiftName("");
                setOpenGift(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 1 }} />
          <Box>
            <Typography variant="subtitle2">
              لطفا کد هدیه جدید را وارد کنید
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <GiftSearchCom
                productID={state.newGiftId}
                productModel={state}
                setProductModel={setState}
                newGiftId
              />
              <Box sx={{ mt: 2 }}>
                <Button
                  onClick={() => {
                    if (!state.newGiftId) {
                      enqueueSnackbar("لطفا کد هدیه جدید را وارد کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                      });
                      return;
                    }
                    ChangeProductGift(state, () => {
                      setGiftName("");
                      setOpenGift(false);
                      setState({
                        newGiftId: undefined,
                        giftID: undefined,
                      });
                      props.callback();
                    });
                  }}
                  sx={{ mr: 2 }}
                  color="secondary"
                  variant="contained"
                >
                  انتقال
                </Button>
                <Button
                  onClick={() => {
                    let model = {
                      giftID: state.giftID ? state.giftID : undefined,
                    };

                    deleteProductgifts(model, () => {
                      setOpenGift(false);
                      setGiftName("");
                      setState({
                        newGiftId: undefined,
                        giftID: undefined,
                      });
                      props.callback();
                    });
                  }}
                  color="secondary"
                  variant="outlined"
                >
                  حذف
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <Box
        sx={{ mt: 4, mb: 2, display: "flex", alignItems: "center", gap: 0.5 }}
      >
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography color="secondary" variant="subtitle1">
          براساس هدیه
        </Typography>
      </Box>
      <Box
        sx={{
          mb: 2,
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={2}
      >
        <Box gridColumn={isSmall ? "span 12" : "span 9"}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <SearchComGift
              changeGift
              productID={state.giftID}
              productModel={state}
              setProductModel={setState}
            />
            <Button
              sx={{ width: "70px" }}
              variant="contained"
              disabled={!state.giftID ? true : false}
              onClick={() => {
                setOpenGift(true);
              }}
            >
              عملیات
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
